import React from "react";
import Topnav from "../components/Topnav.js";
import Footer from "../components/Footer.js";
import Header from "../components/Header.js";
import AccueilBody from "../components/AccueilBody.js";
import Carousel from "../components/CarouselProjets.js";
import Stats from "../components/Stats.js";


const Accueil = () => {

    return (
        <div className="overflowYHidden">

            <Topnav />
            <Header />
            <AccueilBody />
            <Stats />
            <Carousel />
            <Footer />
        </div>
    )
}

export default Accueil;
